import React from 'react';
import Hero from '../components/Hero';
import PolicyLayout from '../components/PolicyLayout';

const TermsOfUse = () => {
    const sections = [
        { h: "1. Acceptance of Terms", p: "By accessing RojrzTech, you agree to be bound by these terms. If you do not agree, please discontinue use." },
        { h: "2. Service Usage", p: "Our services are provided for lawful purposes only. Unauthorized modification of code or content is prohibited." },
        { h: "3. Intellectual Property", p: "All content, designs, and code on this platform are the property of RojrzTech unless otherwise stated." },
        { h: "4. User Conduct", p: "You agree not to disrupt our services or attempt to access unauthorized areas of our infrastructure." },
        { h: "5. Limitation of Liability", p: "RojrzTech is not liable for any direct or indirect damages resulting from the use of our services." },
        { h: "6. Service Updates", p: "We reserve the right to modify or discontinue any part of our services at any time without notice." },
        { h: "7. Account Responsibility", p: "You are responsible for maintaining the confidentiality of your account credentials." },
        { h: "8. Governing Law", p: "These terms are governed by the laws of your jurisdiction without regard to conflict of law provisions." },
        { h: "9. Feedback", p: "Any feedback or suggestions provided by you become the exclusive property of RojrzTech." },
        { h: "10. Termination", p: "We reserve the right to terminate access to our services if you violate these terms." }
    ];

    return (
        <>

            <Hero
                badge="Terms & Conditions"
                title="Terms of Use"
                subtitle="Guidelines and rules to ensure a professional and secure environment for all our clients."
                image="https://images.unsplash.com/photo-1554224155-8d04cb21cd6c?auto=format&fit=crop&q=80&w=800"
                primaryBtnText="Contact Support"
                primaryBtnLink="/contact"
                rating="4.9/5.0"
                clientCount="500+"
            />

            <PolicyLayout title="Terms of Use" seoLabel="Rules & Guidelines">
                <div className="space-y-12">
                    {sections.map((sec, i) => (
                        <div key={i}>
                            <h3 className="text-2xl font-bold text-[#F3CA52] mb-4">{sec.h}</h3>
                            <p className="text-zinc-400 leading-relaxed text-[#FFFFFF]">{sec.p}</p>
                        </div>
                    ))}
                </div>
            </PolicyLayout>
        </>
    );
};

export default TermsOfUse;